import { render, staticRenderFns } from "./agentXZApprove.vue?vue&type=template&id=67be4a8b&scoped=true"
import script from "./agentXZApprove.vue?vue&type=script&lang=js"
export * from "./agentXZApprove.vue?vue&type=script&lang=js"
import style0 from "./agentXZApprove.vue?vue&type=style&index=0&id=67be4a8b&prod&scoped=true&lang=css"
import style1 from "./agentXZApprove.vue?vue&type=style&index=1&id=67be4a8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67be4a8b",
  null
  
)

export default component.exports